import {
  AiCreateArtworkModel,
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
  getAIMenu_pictureGraph_aiCreateArtworkOptionMenu,
  getCollectedStyleModelList_pictureSocialQuery_collectedStyleModelList,
  pollAIArtWork_pictureGraph_aiArtworkGeneratingInfo,
} from '~/graphqls/types'

export type ExtendsProduct = Omit<
  getAIArtWorkNewst36_pictureGraph_aiArtworkPage_edges_node,
  '__typename'
> &
  Partial<
    Omit<pollAIArtWork_pictureGraph_aiArtworkGeneratingInfo, '__typename'>
  >

export const modelOptions = [
  {
    model: AiCreateArtworkModel.STYLE,
    name: '风格模型',
  },
  {
    model: AiCreateArtworkModel.STABLE_DIFFUSION,
    name: '通用模型',
  },
  {
    model: AiCreateArtworkModel.ANIME_DIFFUSION,
    name: '二次元模型',
  },
  {
    model: AiCreateArtworkModel.DISCO_DIFFUSION,
    name: '色彩模型',
  },
]

export type AIOptions = getAIMenu_pictureGraph_aiCreateArtworkOptionMenu & {
  collectedStyleModelList?: getCollectedStyleModelList_pictureSocialQuery_collectedStyleModelList[]
}
